import request from '@/utils/request';

export function getAppCategory() {
  return request({
    url: `/app-server/marketui/category`,
    method: 'get'
  });
}

export function getAppList(params) {
  return request({
    url: `/app-server/marketui/applist`,
    method: 'get',
    params: params
  });
}

export function getMarketList(params) {
  return request({
    url: `/app-server/marketui/markets`,
    method: 'get',
    params: params
  });
}
export function getHotApps(params) {
  return request({
    url: `/app-server/marketui/hotApps`,
    method: 'get',
    params
  });
}

export function getIndexBanners() {
  return request({
    url: `/app-server/marketui/banners`,
    method: 'get'
  });
}

export function getHotSearchKeys(params) {
  return request({
    url: `/app-server/marketui/hotKeywords`,
    method: 'get',
    params
  });
}

export function getHotTags(params) {
  return request({
    url: `/app-server/marketui/hotTags`,
    method: 'get',
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/index.js